module.exports = __webpack_public_path__ + "static/media/world.bfb37330.svg";